import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '~/libs/api';
import type { TApiSupervisorSegment } from '~/modules/covenants/types.ts';
import type { RootState } from '~/store/store.ts';
import { thunkErrorHandler } from '~/store/utils.ts';
import type {
  TCreateSupervisorSegmentRequest,
  TDeleteSupervisorSegmentSupervisorRequest,
  TThunkError,
} from '~/store/covenants/types.ts';

export const fetchSupervisorSegments = createAsyncThunk<
  TApiSupervisorSegment[],
  void,
  { state: RootState; rejectValue: TThunkError }
>('covenantsPage/fetchSupervisorSegments', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.get('/covenants-api/covenants/supervisors/segments');

    return Array.isArray(data) ? data : [];
  } catch (error) {
    return thunkErrorHandler(error, rejectWithValue);
  }
});

export const createSupervisorSegmentSupervisor = createAsyncThunk<
  void,
  TCreateSupervisorSegmentRequest,
  { state: RootState; rejectValue: TThunkError }
>(
  'covenantsPage/createSupervisorSegmentSupervisor',
  async ({ segmentId, email }, { rejectWithValue }) => {
    try {
      await api.post(`/covenants-api/covenants/supervisors/segments/${segmentId}/supervisors`, {
        email,
      });

      return;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const deleteSupervisorSegmentSupervisor = createAsyncThunk<
  void,
  TDeleteSupervisorSegmentSupervisorRequest,
  { state: RootState; rejectValue: TThunkError }
>(
  'covenantsPage/deleteSupervisorSegmentSupervisor',
  async ({ segmentId, supervisorId }, { rejectWithValue }) => {
    try {
      await api.delete(
        `/covenants-api/covenants/supervisors/segments/${segmentId}/supervisors/${supervisorId}`
      );

      return;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);
